export default "__VITE_ASSET__BA7I58J5__"